import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function CurrencyRateListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            detailsHref={"/currency-rate/details"}
                            objectKeys={["id", "currency_from.name", "currency_to.name", "value", "date"]}
                            columnTitles={[
                                "ID", "From", "To", "Value", "Date"
                            ]}
                            pageTitle={"Currency Rates"}
                            readEndpoint={"currency-rate/read"}
                            relations={["currency_from", "currency_to"]}
                            />
        </>
    )
}

export default CurrencyRateListPage;